<ng-template #noItems>
    <p>No device(s) available.</p>
</ng-template>
<div class="dash-grid--item full-width module drop-shadow bottom">
    <div class="dashboard--module-header">
        <h2 class="subheading-md">Select device(s)</h2>
    </div>    
    <form class="module--main module--main__column" [formGroup]="form" (submit)="submit(form)" autocomplete="off" novalidate *ngIf="isLoading || totalItems > 0; else noItems">
        <div class="row u-width__full">
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="flex-grid--item  std-form u-spacing--medium">
                    <div class="form-group">
                        <label for="select-customers">Add device(s)*</label>
                        <div class="row u-spacing--small">
                            <div class="input-inline col-md-6 col-sm-6 col-xs-12">
                                <button type="button" (click)="selectAll()" class="std-btn focus-element"><span class="focus--content" tabindex="-1">Select All</span></button>
                            </div>
                            <div class="organise-select col-md-6 col-sm-6 col-xs-12">
                                <label for="">Sites:</label>
                                <select name="" id="select-site" class="select__standalone" [formControl]="form.controls['site']">
                                    <option [ngValue]="0">All</option>
                                    <option *ngFor="let site of allSites" [ngValue]="site.siteId">{{site.siteName}}</option>
                                </select>
                            </div>
                        </div>
                        <input type="text" id="select-customers" class="input-addon__std--input" [formControl]="form.controls['search']">
                        <ul class="checklist">
                            <li *ngFor="let searchItem of consumerUnSelectedResults; let i = index;" class="checklist--item"><input type="checkbox" [attr.id]="i" (click)="addConsumer(searchItem, i)"><label [attr.for]="i">{{searchItem.consumerAddress}}<svg class="ic-check"><use xlink:href="#ic-check" href="#ic-check"></use></svg></label></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="flex-grid--item  std-form u-spacing--medium">
                    <div class="form-group">
                        <label for="selected-customers">Selected device(s)*</label>
                        <div class="row u-spacing--small">
                            <div class="input-inline col-md-6 col-sm-6 col-xs-12">
                                <button type="button" (click)="removeAll()" class="std-btn focus-element"><span class="focus--content" tabindex="-1">Remove All</span></button>
                            </div>
                        </div>
                        <input type="text" id="selected-customers" class="input-addon__std--input" [formControl]="form.controls['selectedSearch']">
                        <ul class="checklist">
                            <li *ngFor="let selectedItem of consumerSelectedResults; let i = index;" class="checklist--item"><input type="checkbox" [attr.id]="selectedItem.consumerId" (click)="removeConsumer(selectedItem, i)"><label [attr.for]="selectedItem.consumerId">{{selectedItem.consumerAddress}}<svg class="ic-check"><use xlink:href="#ic-check" href="#ic-check"></use></svg></label></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group danger" *ngIf="submitted">
            <span *ngIf="!consumerSelectedResults || consumerSelectedResults.length == 0" class="validation-msg">please select at least one consumer*</span>
        </div>
        <button class="std-btn focus-element" type="submit"><span class="focus--content" tabindex="-1">Next</span></button>
    </form>
</div>
